module.exports = __webpack_public_path__ + "img/cameraSection.9830f903.svg";